for (let image of document.querySelectorAll('img[sizes="1px"]')) {
    image.setAttribute('sizes', Math.ceil(image.getBoundingClientRect().width/window.innerWidth*100)+'vw');
}